export default __webpack_public_path__ + "static/assets/f6d8b5361eca751dad73abc882ef1136.png";